<template>
  <avz-statuses />
</template>

<script>
import Statuses from '@/components/Statuses'

export default {
  components: {
    'avz-statuses': Statuses
  }
}
</script>
